<template>
  <WsCreate
    :label="label"
    :fields="fields"
    :modelName="modelName"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
  />
</template>

<script>
import model from '@/models/alliance';

export default {
  data() {
    return {
      modelName: model.modelName,
      label: model.label,
      fields: model.fields,
      pageSetting: {
        primary: [
          {
            type: 'infoCard',
            floors: [
              {
                fields: [
                  'locales',
                  'remark',
                  'logo',
                  'related_modules',
                ],
              },
            ],
          },
        ],
        secondary: [
          {
            type: 'infoCard',
            floors: [
              {
                title: '設定',
                fields: [
                  'area',
                ],
              },
            ],
          },
        ],
      },
    };
  },
};
</script>